export var MentionType = /*#__PURE__*/ function(MentionType) {
    MentionType["Document"] = "DOCUMENT";
    MentionType["SpaceTab"] = "SPACE_TAB";
    MentionType["Task"] = "TASK";
    MentionType["User"] = "USER";
    MentionType["Team"] = "TEAM";
    MentionType["Role"] = "ROLE";
    MentionType["Group"] = "GROUP";
    MentionType["Vendor"] = "VENDOR";
    MentionType["Client"] = "CLIENT";
    MentionType["Company"] = "COMPANY";
    return MentionType;
}({});
export const mention = (feed, marker = '@', minimumCharacters = 1)=>({
        feeds: [
            {
                marker,
                minimumCharacters,
                feed
            }
        ]
    });
